import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                caption: '',
                description: '',
                reference_id: '',
                hls_url: '',
                resolved_hls_url: null,
                hls_cookies: null,
                thumbnail_url: '',
                resolved_thumbnail_url: null,
                thumbnail_signed_url: null,
                title: '',
                video: null,
                uuid: null,
                tags: [],
                groups: [],
                course_codes: [],
                statuses: [],
                video_activities: null,
                video_activity_templates: null,
                created_at: null,
                updated_at: null,
                archived_at: null,
            };
        },

        getters: {},

        actions: {
            edit(context, { field, value }) {
                context.commit('EDIT_FIELD', { field, value });

                context.commit(
                    'Videos/AUTO_SAVE',
                    { item: context.state, field },
                    {
                        root: true,
                    }
                );
            },
        },

        mutations: {
            EDIT_FIELD(state, { field, value }) {
                state[field] = value;
            },
        },
    }
);
